import { render, staticRenderFns } from "./LegConfiguration.vue?vue&type=template&id=55652eb0&lang=pug"
import script from "./LegConfiguration.vue?vue&type=script&lang=js"
export * from "./LegConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports